export default __webpack_public_path__ + "static/media/Gift 2018 -- Ink on Paper -- 6in x 8 in.63016004.JPG";